import { useState } from "react";
import { Plus } from "lucide-react";
import { Reveal } from "./Reveal";
import "./FAQs.css";

const FAQS = [
    {
        question: "How much does it cost?",
        answer: "It depends on upload volume and what you need done. We do not publish rates because no two channels need the same thing. Book a call and you will have a number within 24 hours.",
    },
    {
        question: "What do I need to give you?",
        answer: "Raw footage and access to your channel analytics. That is it. We handle the rest.",
    },
    {
        question: "How fast is turnaround?",
        answer: "Standard Short-Form first cuts come back within 48 hours, ready to publish in 72. Long-Form first cuts come back within 72 hours, ready to publish in 96. Rush is available.",
    },
    {
        question: "Do you work with channels under 100K subscribers?",
        answer: "Yes, if you are recording consistently. Growth comes from volume and packaging, and both need a steady supply of recordings.",
    },
    {
        question: "Who actually edits my videos?",
        answer: "A dedicated editor assigned to your channel, so the style stays consistent. AI tools speed up cuts, captions and research; a person makes every creative decision.",
    },
    {
        question: "How many revisions are included?",
        answer: "Two rounds of revisions on every video.",
    },
    {
        question: "What types of revisions are included?",
        answer: "Corrections and changes.",
    },
    {
        question: "Do you help with content branding and direction?",
        answer: "If you have a clear vision, then yes, we can do it.",
    },
    {
        question: "Is there a guarantee?",
        answer: "We don't promise algorithm, but we promise quality and volume, and quality gets results. Usually a three month window is good to test and fix and predict results.",
    },
    {
        question: "Can I cancel?",
        answer: "Yes. Plans run month to month. Cancel before your next billing date and we wrap up anything already in progress; everything delivered is yours to keep.",
    },
];

export const FAQs = () => {
    const [openIndex, setOpenIndex] = useState(null);

    return (
        <section className="section faqs" id="faqs" data-testid="faqs-section">
            <div className="section-inner faqs-inner">
                <div className="faqs-header">
                    <p className="eyebrow" data-testid="faqs-eyebrow">
                        FAQs
                    </p>
                    <h2 className="section-heading" data-testid="faqs-heading">
                        Things people <span className="serif">ask</span> first.
                    </h2>
                </div>

                <div className="faqs-accordion" data-testid="faqs-accordion">
                    {FAQS.map((faq, i) => {
                        const open = openIndex === i;
                        return (
                            <Reveal
                                className={`faq-item${open ? " faq-item-open" : ""}`}
                                key={faq.question}
                                delay={i * 0.05}
                                data-testid={`faq-item-${i + 1}`}
                            >
                                <button
                                    type="button"
                                    className="faq-question"
                                    onClick={() =>
                                        setOpenIndex(open ? null : i)
                                    }
                                    aria-expanded={open}
                                    data-testid={`faq-question-${i + 1}`}
                                >
                                    {faq.question}
                                    <Plus
                                        size={20}
                                        className="faq-icon"
                                        aria-hidden="true"
                                    />
                                </button>
                                <div
                                    className="faq-answer"
                                    data-testid={`faq-answer-${i + 1}`}
                                >
                                    <div className="faq-answer-inner">
                                        <p>{faq.answer}</p>
                                    </div>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
